import { TrackingEvent } from '@bridebook/web/lib/track-utils/tracking-event';

export const mapEventToAppsFlyerEvent = (event: TrackingEvent) => eventToAppsFlyerEvent[event];

enum AppsflyerTrackingEvent {
  SignedUp = 'af_complete_registration',
  AfContentView = 'af_content_view',
  AfAddToCart = 'af_add_to_cart',
  TriggeredEnquiryForm = 'af_initiated_checkout',
  SendEnquiry = 'af_purchase',
  InitializedChecklist = 'initialised_checklist',
  UpdatedMainTasks = 'updated_main_tasks',
  UpdatedSubtasks = 'updated_subtasks',
  InitializedGuestList = 'initialised_guest_list',
  AddedMultipleGuests = 'added_multiple_guests',
  AddedGuest = 'added_guest',
  CalculatedBudget = 'calculated_budget',
  UpdatedBudget = 'updated_budget',
  UpdatedBudgetItem = 'updated_budget_item',
  CompletedOnboarding = 'af_tutorial_completion',
  LoadedSearchResults = 'af_search',
}

const eventToAppsFlyerEvent: Record<TrackingEvent, string> = {
  [TrackingEvent.SignedUp]: AppsflyerTrackingEvent.SignedUp,
  [TrackingEvent.CompletedOnboarding]: AppsflyerTrackingEvent.CompletedOnboarding,
  [TrackingEvent.LoadedSearchResults]: AppsflyerTrackingEvent.LoadedSearchResults,
  [TrackingEvent.ViewedSupplierProfile]: AppsflyerTrackingEvent.AfContentView,
  [TrackingEvent.ShortlistedSupplier]: AppsflyerTrackingEvent.AfAddToCart,
  [TrackingEvent.InitializedChecklist]: AppsflyerTrackingEvent.InitializedChecklist,
  [TrackingEvent.UpdatedMainTasks]: AppsflyerTrackingEvent.UpdatedMainTasks,
  [TrackingEvent.UpdatedSubtasks]: AppsflyerTrackingEvent.UpdatedSubtasks,
  [TrackingEvent.InitializedGuestList]: AppsflyerTrackingEvent.InitializedGuestList,
  [TrackingEvent.AddedMultipleGuests]: AppsflyerTrackingEvent.AddedMultipleGuests,
  [TrackingEvent.AddedGuest]: AppsflyerTrackingEvent.AddedGuest,
  [TrackingEvent.CalculatedBudget]: AppsflyerTrackingEvent.CalculatedBudget,
  [TrackingEvent.UpdatedBudget]: AppsflyerTrackingEvent.UpdatedBudget,
  [TrackingEvent.TriggeredEnquiryForm]: AppsflyerTrackingEvent.TriggeredEnquiryForm,
  [TrackingEvent.SendEnquiry]: AppsflyerTrackingEvent.SendEnquiry,
  [TrackingEvent.UpdatedBudgetItem]: AppsflyerTrackingEvent.UpdatedBudgetItem,
};
